<template>
  <div class="h-10 bg-gray-100"></div>
  <div class="product-page">
    <!-- Mobile Navigation Menu (only visible on small screens) -->
    <div class="block md:hidden sticky top-0 bg-white z-10 border-b border-border py-3">
      <div class="px-4 flex justify-between items-center">
        <span class="text-sm font-medium text-dark">{{ productType }} Insurance</span>
        <button @click="showMobileNav = !showMobileNav" class="text-dark">
          <span v-if="!showMobileNav">Menu</span>
          <span v-else>Close</span>
        </button>
      </div>
      
      <!-- Mobile Navigation Drawer -->
      <div v-if="showMobileNav" class="px-4 py-3 bg-subtle">
        <ul class="space-y-4">
          <slot name="sidebar-nav"></slot>
        </ul>
      </div>
    </div>
  
    <div class="md:flex justify-between">
      <div class="left-side md:w-[30%] relative">
        <div class="product-sidebar xl:w-[300px] lg:w-[288px] md:w-[230px] px-5 mt-[50px]">
          <div class="hidden md:block">
            <ul>
              <slot name="sidebar-nav"></slot>
            </ul>
          </div>
        </div>
      </div>
      <div class="right-side px-5 md:w-[70%]">
        <div>
          <div class="flex text-xs items-center text-dark uppercase">
            <span class="pr-5 hover-text-primary transition-colors duration-300">Insurance</span>
            <span class="pr-5">
              <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 12C7.5 11.5858 7.83579 11.25 8.25 11.25L15.75 11.25C16.1642 11.25 16.5 11.5858 16.5 12C16.5 12.4142 16.1642 12.75 15.75 12.75L8.25 12.75C7.83579 12.75 7.5 12.4142 7.5 12Z" fill="currentColor"/>
              </svg>
            </span>
            <span class="hover-text-primary transition-colors duration-300">
              {{ productType }} Insurance
            </span>
          </div>
          
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseProductPage',
  props: {
    productType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showMobileNav: false
    }
  }
};
</script>

<style>
/* You can define shared styles for product pages here */
</style> 